import React from 'react';

import makeStyles from '@material-ui/styles/makeStyles';
import UserProfileIcon from '../../Analytics/TotalsListWidget/TotalsListItem/Icons/UserProfile';

const useStyles = makeStyles({
    root: {
        flexDirection: 'column',
        alignItems: 'left',
    },
    icon: {
        width: '2.1875rem',
    },
    name: {
        fontWeight: 600,
        margin: '0.25rem',
    },
    number: {
        margin: '0.25rem',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
    },
});

export interface ICustomerMainDetailsCard {
    name: string;
    number?: string;
    email?: string;
}

const CustomerMainDetailsCard = (props: ICustomerMainDetailsCard) => {
    const classes = useStyles();
    return (
        <div className={classes.root} data-component-name={'CUSTOMER_MAIN_DETAILS_CARD'}>
            <div className={classes.icon}>
                <UserProfileIcon />
            </div>
            <div className={classes.name}>{props.name}</div>
            <div className={classes.number}>{props.number || props.email}</div>
        </div>
    );
};

export default CustomerMainDetailsCard;
